module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teaser full-screen d-flex flex-column align-items-top justify-content-start"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-5 mr-4"
  }, [_c('router-link', {
    staticClass: "btn outlined action wide mr-5",
    attrs: {
      "to": {
        name: 'auth.login'
      },
      "tag": "div"
    }
  }, [_vm._v("\n            Log in\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn outlined action wide",
    attrs: {
      "to": {
        name: 'auth.signup'
      },
      "tag": "div"
    }
  }, [_vm._v("\n            Sign in\n        ")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1b57044c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b57044c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Teaser.vue
// module id = 1210
// module chunks = 0